<template>
  <AjaxLoader v-if="ajaxLoading" />
  <div class="devis" :class="[`stage-${currentStep}`]">
    <SummarySidebar />
    <div class="devis__content">
      <div class="container">
        <h1 class="devis__title">{{ apiData.pageTitle }}</h1>
        <StagePage stage="currentStage" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapState } from 'pinia'

import { useStagesStore } from './stores/stages'
import SummarySidebar from './components/SummarySidebar.vue'
import StagePage from './components/StagePage.vue'
import AjaxLoader from './components/AjaxLoader.vue'

export default {
  components: {
    AjaxLoader,
    StagePage,
    SummarySidebar,
  },
  computed: {
    ...mapState(useStagesStore, ['currentStep', 'apiData', 'ajaxLoading']),
  },
  mounted() {
    // Add the API data to the store, or display an error message.
    axios
      .get(this.vals.devisApi)
      .then((response) => {
        this.isWaiting = false
        this.setApiData(response.data.body)
      })
      .catch((error) => {
        this.error.show = true
        this.error.message = error.response.data.message
      })
  },
  methods: {
    ...mapActions(useStagesStore, ['setApiData']),
  },
}
</script>

<style lang="scss">
.app-error {
  background-color: $red-100;
  color: $red-500;
  padding: 20px 40px;
  margin-bottom: 30px;
  border: 1px solid $red-100;
  font-size: 20px;
  font-weight: 700;
}

#devis {
  background-color: var(--vn-req-bg-color);
}

.devis {
  $this: &;

  display: flex;

  &.stage-4 {
    #{$this}__content {
      @include media-breakpoint-down(lg) {
        padding: 150px 0 100px;
      }

      @include media-breakpoint-down(md) {
        width: 100%;
        padding: 150px 0 100px 0;
      }
    }
  }

  &__content {
    flex-grow: 1;
    padding: 150px 0;
    width: calc(100% - 400px);
    position: relative;

    @include media-breakpoint-down(lg) {
      padding: 50px 0 100px;
      width: calc(100% - 300px);
    }

    @include media-breakpoint-down(md) {
      width: 100%;
      padding: 30px 0 100px;
    }

    > .container {
      @include media-breakpoint-up(md) {
        padding-left: 40px;
        padding-right: 40px;
      }
    }
  }

  &__title {
    @include rfs(32px);
    margin: 0 0 10px;
  }
}

@import './assets/scss/app';
@import './assets/scss/button';
@import './assets/scss/offer';
@import './assets/scss/toggle';
</style>
